import type { PurchaseRecord } from '../components/PurchaseHistory'
import { authenticatedFetch } from './auth'

export interface PurchaseHistoryPage { records: PurchaseRecord[]; nextOffset: number | null }
export async function getPurchaseHistory(offset = 0): Promise<PurchaseHistoryPage> {
    const response = await authenticatedFetch(`/api/mobile-shop/purchaseHistory?offset=${offset}`, { cache: 'no-store' })
    if (!response.ok) throw new Error('Kaufhistorie konnte nicht geladen werden.')
    const json = await response.json()
    if (json.r !== true || !Array.isArray(json.data?.records)) throw new Error('Ungültige Kaufhistorie.')
    return json.data
}
